export const CONTACT = {
  owner: "Arun Tayal",
  phoneDisplay: "+91 98736 28088",
  phoneHref: "tel:+919873628088",
  whatsapp:
    "https://wa.me/919873628088?text=Hi%20Shri%20Radhey%20Krishna%20Bath%20%26%20Tiles%2C%20I%20saw%20your%20website%20and%20would%20like%20to%20know%20more%20about%20your%20collection.",
  email: "shriradheykrishnabathandtiles@gmail.com",
  address: "Tigaon Road, Vill. Bhudena, Near Indian Bank, Sec-86, Sai Dham Marg, Greater Faridabad-121002 (HR)",
  mapsUrl: "https://maps.app.goo.gl/5xZiLWGKcTMHMJCH7",
  mapEmbed: "https://www.google.com/maps?q=28.4024681,77.3486755&z=17&output=embed",
  hours: "Monday – Sunday · 10:00 AM – 8:00 PM",
};

export const IMG = {
  heroShowroom: "/hero.jpg",
  bathtub:
    "https://images.unsplash.com/photo-1610178169668-530baa052915?q=85&w=1600&auto=format&fit=crop",
  shower:
    "https://images.unsplash.com/photo-1771239048293-72abf673adb2?q=85&w=1600&auto=format&fit=crop",
  marbleBasin:
    "https://images.unsplash.com/photo-1754788358645-d6e6cca12e25?q=85&w=1600&auto=format&fit=crop",
  brassSink:
    "https://images.unsplash.com/photo-1771681744660-d3ff70bc24a2?q=85&w=1600&auto=format&fit=crop",
  blackOval:
    "https://images.unsplash.com/photo-1769763917830-7b9c8317329d?q=85&w=1600&auto=format&fit=crop",
  marbleDoubleVanity:
    "https://images.unsplash.com/photo-1756079664354-34944e001f6d?q=85&w=1600&auto=format&fit=crop",
  goldenVanity:
    "https://images.unsplash.com/photo-1764475501545-d5cc9719af1a?q=85&w=1600&auto=format&fit=crop",
  elegantFixtures:
    "https://images.unsplash.com/photo-1754574741164-a41418029cfb?q=85&w=1600&auto=format&fit=crop",
  tubWindow:
    "https://images.unsplash.com/photo-1733426107854-ee00a25d72a7?q=85&w=1600&auto=format&fit=crop",
  elegantLighting:
    "https://images.unsplash.com/photo-1742134131017-44d377a611b1?q=85&w=1600&auto=format&fit=crop",
  marbleBrassVanity:
    "https://images.unsplash.com/photo-1777014547456-7d94a04382ee?q=85&w=1600&auto=format&fit=crop",
  vintageMarble:
    "https://images.unsplash.com/photo-1764551164990-298160bcea48?q=85&w=1600&auto=format&fit=crop",
  blackFaucet:
    "https://images.unsplash.com/photo-1773177930292-463ca3c5b86a?q=85&w=1600&auto=format&fit=crop",
  tubVanity:
    "https://images.unsplash.com/photo-1594873672629-61079318a5fd?q=85&w=1600&auto=format&fit=crop",
  vanity:
    "https://images.unsplash.com/photo-1634320611782-e7589d174453?q=85&w=1600&auto=format&fit=crop",
};

export const MARQUEE_ITEMS = [
  "JAQUAR",
  "KOHLER",
  "HINDWARE",
  "KAJARIA",
  "SOMANY",
  "NITCO",
  "KALINGA STONE",
  "CERA",
  "AGL",
  "SIMPOLO",
  "ASTRAL",
  "KENT RO",
  "ZERO B",
];

export const BRAND_PARTNERS = [
  { name: "Jaquar", logo: "/logos/jaquar.png" },
  { name: "Kohler", logo: "/logos/kohler.png" },
  { name: "Hindware", logo: "/logos/hindware.png" },
  { name: "Kajaria", logo: "/logos/kajaria.png" },
  { name: "Somany", logo: "/logos/somany.png" },
  { name: "Nitco", logo: "https://www.nitco.in/images/nitco-logo.png" },
  { name: "Kalinga Stone", logo: "/logos/kalinga.png" },
  { name: "Cera", logo: "https://www.cera-india.com/sites/default/files/2021-08/Cera_logo_for_Our_Brands.svg" },
  { name: "AGL", logo: "/logos/agl.png" },
  { name: "Simpolo", logo: "https://simpolo-web.s3.ap-south-1.amazonaws.com/uploads/media/logo/black-logo-400-x-252.png" },
  { name: "RAK Ceramics", logo: "https://d3hdqda5v86kzc.cloudfront.net/static/themes/images/interface/logo/logo_og.png" },
  { name: "Johnson", logo: "https://www.hrjohnsonindia.com/assets/images/logo-johnson.png" },
  { name: "Astral Pipes", logo: "https://www.astralltd.com/wp-content/uploads/2022/11/logo.png" },
  { name: "Fusion Pipes", logo: "https://www.fusionpipes.com/main-images/logo/logo-main.png" },
  { name: "Kent RO", logo: "https://www.kent.co.in/cdn/shop/files/kent-logo-hop.svg" },
  { name: "Zero B", logo: "/logos/zerob.svg" },
];

export const BRANDS = [
  {
    id: "jaquar",
    name: "Jaquar",
    tagline: "Complete bathroom solutions & the Artize luxury atelier",
    highlights: ["Sensor Faucets", "Thermostatic Showers", "Whirlpool Bathtubs", "Artize Designer Series"],
    image: IMG.brassSink,
    logos: [{ name: "Jaquar", logo: "/logos/jaquar.png" }],
    blurb:
      "India's most awarded bathware house. From Artize's sculptural faucets to wellness whirlpools, we stock Jaquar's complete flagship range with live working displays.",
  },
  {
    id: "kohler",
    name: "Kohler",
    tagline: "Bold design, intelligent sanitaryware",
    highlights: ["Veil Intelligent Toilets", "Statement Showering", "Matte Black & Rose Gold", "Designer Basins"],
    image: IMG.blackOval,
    logos: [{ name: "Kohler", logo: "/logos/kohler.png" }],
    blurb:
      "150 years of bold craft. Experience Kohler's intelligent toilets, statement showering and gallery-grade finishes — all under one roof in Greater Faridabad.",
  },
  {
    id: "hindware",
    name: "Hindware",
    tagline: "Italian design language, smart hygiene innovation",
    highlights: ["Rimless Wall-Hung WCs", "Overcounter Basins", "Touchless Flushes", "Wellness Steam Cabins"],
    image: IMG.marbleDoubleVanity,
    logos: [{ name: "Hindware", logo: "/logos/hindware.png" }],
    blurb:
      "Where Italian silhouettes meet Indian homes. Hindware's rimless closets, designer basins and touchless hygiene systems, curated and installed by our specialists.",
  },
  {
    id: "designer-tiles",
    name: "Designer Tiles",
    tagline: "Kajaria · Somany · Nitco · Kalinga Stone · AGL & more",
    highlights: ["600×1200 PGVT Slabs", "600×600 Floor Tiles", "Wood & Marble Looks", "Anti-Skid Outdoor Range"],
    image: IMG.elegantLighting,
    logos: [
      { name: "Kajaria", logo: "/logos/kajaria.png" },
      { name: "Somany", logo: "/logos/somany.png" },
      { name: "Nitco", logo: "https://www.nitco.in/images/nitco-logo.png" },
      { name: "Kalinga Stone", logo: "/logos/kalinga.png" },
    ],
    blurb:
      "India's top tile houses on one floor — Kajaria, Somany, Nitco, Kalinga Stone, AGL, Simpolo and more, in the two formats every home needs: 600×1200 and 600×600.",
  },
];

export const TILE_KINDS = [
  { name: "Floor Tiles", desc: "600×1200 & 600×600 vitrified", image: "https://images.pexels.com/photos/6175107/pexels-photo-6175107.jpeg?auto=compress&cs=tinysrgb&w=900" },
  { name: "Wall Tiles", desc: "Kitchen & bathroom walls", image: "https://images.pexels.com/photos/9992549/pexels-photo-9992549.jpeg?auto=compress&cs=tinysrgb&w=900" },
  { name: "Decor Tiles", desc: "Patterns & 3D textures", image: "https://images.pexels.com/photos/35930705/pexels-photo-35930705.jpeg?auto=compress&cs=tinysrgb&w=900" },
  { name: "Mosaic", desc: "Glass & ceramic sheets", image: "https://images.pexels.com/photos/8135498/pexels-photo-8135498.jpeg?auto=compress&cs=tinysrgb&w=900" },
  { name: "Subway Tiles", desc: "Classic metro tiles", image: "https://images.pexels.com/photos/8143708/pexels-photo-8143708.jpeg?auto=compress&cs=tinysrgb&w=900" },
  { name: "Outdoor & Anti-Skid", desc: "Parking & balcony grip", image: "https://images.pexels.com/photos/7587475/pexels-photo-7587475.jpeg?auto=compress&cs=tinysrgb&w=900" },
];

export const MANIFESTO = [
  { num: "01", title: "A 50-Year Family Legacy", desc: "Our family has traded in building materials for over five decades. Shri Radhey Krishna brings that legacy — the sourcing depth, the brand relationships, the fair dealing — home to Faridabad." },
  { num: "02", title: "Authorised Brand Gallery", desc: "Official channel stock for Jaquar, Kohler and Hindware, plus India's top tile houses. Genuine billing, full brand warranty, live displays." },
  { num: "03", title: "Architect & Developer Desk", desc: "BOQ support, project pricing and scheduled site deliveries for architects, builders and premium residences across Faridabad and NCR." },
  { num: "04", title: "Installation Support", desc: "End-to-end coordination with your contractor and plumber. We stay available until the last grout line cures." },
];

export const TESTIMONIALS = [
  { name: "Rohit Malhotra", role: "Homeowner, Sector 86 Faridabad", text: "Bought our full Kajaria floor and Jaquar fittings here. Prices were better than the big tile markets and delivery reached our site same week." },
  { name: "Ar. Meghna Sood", role: "Principal Architect, Studio Meraki", text: "Their BOQ support is genuinely useful — they flag stock issues before I commit a client, and their slab selection rivals anything in Gurgaon. My default showroom in Faridabad." },
  { name: "Aman Raghav", role: "Developer, Sector 84 Projects", text: "We've sourced fittings for three projects through Arun ji. Scheduled deliveries, proper GST billing and warranty papers every single time. Rare reliability." },
];

export const INTERESTS = [
  "Jaquar Fittings",
  "Kohler Sanitaryware",
  "Hindware Bathware",
  "Tiles (Kajaria / Somany / Others)",
  "Pipes / Water Purifiers",
  "Architect / Developer Enquiry",
  "Full Bathroom Renovation",
  "Other",
];
